import { TabContext, TabList, TabPanel } from '@mui/lab';
import { Box } from '@mui/material';
import Tab from '@mui/material/Tab';

import React, { SyntheticEvent, useState } from 'react';
import DefenseDevicesPage from './Devices';
import DefenseEventsPage from './Events';
import DefenseBridgePage from './Bridge';
import HeaderDashboard from 'pages/DashboardPageClient/_components/_ui/Header';

const DefensePages = () => {
  const [value, setValue] = useState('1');

  const handleChange = (event: SyntheticEvent, newValue: string) => {
    setValue(newValue);
  };

  return (
    <>
      <TabContext value={value}>
        <Box
          sx={{
            borderBottom: 1,
            borderColor: 'divider',
            width: '50%',
          }}
        >
          <TabList onChange={handleChange}>
            <Tab label="Dispositivos" value="1" />
            <Tab label="Eventos" value="2" />
            <Tab label="Bridge" value="3" />
          </TabList>
        </Box>
        <TabPanel value="1">
          <DefenseDevicesPage />
        </TabPanel>
        <TabPanel value="2">
          <DefenseEventsPage />
        </TabPanel>
        <TabPanel value="3">
          <DefenseBridgePage />
        </TabPanel>
      </TabContext>
    </>
  );
};

export default DefensePages;
